export default __webpack_public_path__ + "static/services_02-fd07b571dd1d1436ab212e6394e04c24.png";